// SplashScreenPageLinear.tsx
import { motion } from "framer-motion";
import styled from "styled-components";

// Container principale
export const SplashScreenLinear = styled.div`
  position: absolute;
  width: calc(100% - 2rem);
  height: calc(100vh - 82px);
  display: flex;
  flex-direction: column; // cambia in 'row' se vuoi layout orizzontale
  align-items: center;
  justify-content: center;
  gap: 1rem;

  &.make-disappear {
        animation: splashDisappearing 1s forwards; 
    }
`;

// Shape 1 e 2 condividono lo stile base
export const ShapeBase = styled(motion.div)`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// Blob interni alle shape
export const Blob1 = styled.div`
  width: 240px;
  height: 240px;
  background-color: #eef7ed;
  border-radius: 65% 35% 45% 55% / 55% 45% 65% 35%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
`;

export const Blob2 = styled.div`
  width: 190px;
  height: 160px;
  background-color: #ddf0db;
  border-radius: 60px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.08);
`;

export const LogoContainer = styled(motion.div)`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;

export const LogoLinear = styled.img`
  width: 115px;
  height: auto;
`;
